import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { useSelector } from "react-redux";
import InputImageByte from "../../UI/InputImageByte";
import { ADMIN } from "../../Usuario/Perfil";

const previewSx = {
  width: "100%",
  maxWidth: 640,
  aspectRatio: "16 / 9",
  objectFit: "contain",
  bgcolor: "action.hover",
  borderRadius: 2,
  border: 1,
  borderColor: "divider",
  display: "block",
};

const ComunicadoBannerForm = ({
  handleSubmit,
  setComunicadoBanner,
  comunicadoBanner,
  isLoadingAction,
  handleRemove,
}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const usuario = useSelector((state) => state.usuario);
  const isNovo = !!comunicadoBanner.eNovo;
  const isAdmin = usuario?.perfil === ADMIN;

  useEffect(() => {
    if (!file) return;
    const objectUrl = URL.createObjectURL(file);
    setPreview(objectUrl);
    // libera a memória do preview anterior / ao desmontar
    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  const handleChangeImage = (e) => {
    setFile(e.target.files[0] ?? null);
  };

  const handleSubmitInit = (event) => {
    event.preventDefault();
    if (!file) return;

    const fileFormData = new FormData();
    fileFormData.append("file", file);
    handleSubmit(fileFormData);
  };

  const loadingIcon = <CircularProgress size={16} color="inherit" />;

  return (
    <Box component="form" onSubmit={handleSubmitInit}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => setComunicadoBanner(null)}
        disabled={isLoadingAction}
        sx={{ mb: 2 }}
      >
        Voltar
      </Button>

      <Typography variant="subtitle1" fontWeight={600} mb={2}>
        {isNovo ? "Novo banner" : "Banner selecionado"}
      </Typography>

      {isNovo ? (
        <Box sx={{ "& img": previewSx }}>
          <InputImageByte
            image={preview}
            handleChangeImage={handleChangeImage}
            multiple={false}
          />
        </Box>
      ) : (
        <Box
          component="img"
          src={comunicadoBanner.urlBanner}
          alt={`Banner ${comunicadoBanner.codigo}`}
          sx={previewSx}
        />
      )}

      <Stack direction="row" spacing={2} mt={3}>
        {isNovo && (
          <Button
            type="submit"
            variant="contained"
            disabled={!file || isLoadingAction}
            startIcon={isLoadingAction ? loadingIcon : <SaveOutlinedIcon />}
          >
            Salvar
          </Button>
        )}
        {!isNovo && isAdmin && (
          <Button
            type="button"
            variant="outlined"
            color="error"
            disabled={isLoadingAction}
            onClick={handleRemove}
            startIcon={isLoadingAction ? loadingIcon : <DeleteOutlineIcon />}
          >
            Remover
          </Button>
        )}
      </Stack>
    </Box>
  );
};

export default ComunicadoBannerForm;
